import {
  dashboardActions,
  dashboardCampaign,
  dashboardCreative,
  dashboardHeader,
  dashboardPerformance,
  dashboardRow,
  dashboardStatus
} from './dashboard';
import { exporting } from './export';
import { filters } from './filters';
import { layoutControls } from './layout';
import { campaignsOverview } from './overview';

let overviewSteps = [
  campaignsOverview,
  filters,
  exporting,
  layoutControls,
  dashboardHeader,
  dashboardRow,
  dashboardCreative,
  dashboardCampaign,
  dashboardPerformance,
  dashboardStatus,
  dashboardActions
];

export const OVERVIEW_STEPS = overviewSteps;
